const displayValueWithSymbol = value => {
  const searchRS = value?.toString()?.search('Rs.');
  if (searchRS >= 0) {
    value = `${value?.replace('Rs.', '').trim()}`;
  }
  return `₹${value}`;
};

const displayValueWithoutDecimal = value => {
  const searchRS = value.toString().search('Rs.');
  const isString = typeof value === 'string';
  if (searchRS >= 0) {
    value = `${value?.replace('Rs.', '').trim()}`;
  }
  if (isString && value.includes('.')) {
    value = value.slice(0, value.lastIndexOf('.'));
  }
  return `₹${value}`;
};

const displayValueWithoutSymbol = value => {
  const searchRS = value.toString().search('₹');
  if (searchRS >= 0) {
    return `${value?.replace('₹', '')}`;
  }
  return value;
};

const getDiscountValue = value => {
  const isString = typeof value === 'string';
  if (value && isString && (value.includes('%') || value.toLowerCase().includes('off'))) {
    return `${parseInt(value.split('%')[0])}% off`;
  }
  return value;
};

const getDiscountValueWithoutPercentage = value => {
  const isString = typeof value === 'string';
  if (value && isString && (value.includes('%') || value.toLowerCase().includes('off'))) {
    return `${parseInt(value.split('%')[0])}`;
  }
  return value;
};

export {
  displayValueWithSymbol,
  displayValueWithoutSymbol,
  getDiscountValue,
  getDiscountValueWithoutPercentage,
  displayValueWithoutDecimal
};
